// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"0fea4bee","235":"244b8479","453":"4d18d495","758":"2853b51c"}[chunkId] + ".chunk.js";
};